import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "file-outline",
			d: "M13.3333 6.65873V11.4666C13.3333 12.5867 13.3333 13.1467 13.1153 13.5746C12.9236 13.9509 12.6176 14.2569 12.2413 14.4486C11.8135 14.6666 11.2534 14.6666 10.1333 14.6666H5.86666C4.74655 14.6666 4.1865 14.6666 3.75868 14.4486C3.38235 14.2569 3.07639 13.9509 2.88464 13.5746C2.66666 13.1467 2.66666 12.5867 2.66666 11.4666V4.53325C2.66666 3.41315 2.66666 2.85309 2.88464 2.42527C3.07639 2.04895 3.38235 1.74299 3.75868 1.55124C4.1865 1.33325 4.74655 1.33325 5.86666 1.33325H8.00784C8.49702 1.33325 8.74161 1.33325 8.97179 1.38851C9.17586 1.43751 9.37095 1.51831 9.54989 1.62797C9.75173 1.75166 9.92468 1.92461 10.2706 2.27051L12.3961 4.39599C12.742 4.7419 12.9149 4.91485 13.0386 5.11668C13.1483 5.29563 13.2291 5.49072 13.2781 5.69479C13.3333 5.92496 13.3333 6.16955 13.3333 6.65873Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "file-fold",
			d: "M9.33332 1.51294V4.26663C9.33332 4.64 9.33332 4.82669 9.40599 4.96929C9.4699 5.09473 9.57189 5.19672 9.69733 5.26064C9.83994 5.3333 10.0266 5.3333 10.4 5.3333H13.1537",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "file-line file-line--top",
			d: "M10.6667 8.66658H5.33332",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "file-line file-line--bottom",
			d: "M9.33332 11.3333H5.33332",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFile;
